import { useDispatch } from "react-redux";
import type { AppDispatch } from "../../WebsiteStore";

export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
